import React from 'react';

import {
  BrowserRouter,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';

import {
  SessionsKeys
} from 'src/Common/constants';

import {
  Loader,
  CallMeBackPopup
} from 'src/Components/Common';

import {
  NavLayoutRouteWrapper,
  Routes
} from 'src/Navigation';

import LocalConfigs from 'src/config';

import {
  SalesContext
} from './Context/SalesContext';

import {
  setTrackingIds
} from './Utility/utility';

import './App.css';

const loadDevSessionsData = () => {

  try {
    if (process.env?.NODE_ENV !== 'development' || !LocalConfigs?.fibreLeadsAddress) {
      return;
    }

    if (!sessionStorage.getItem(SessionsKeys.FibreLeadsAddress)) {
      sessionStorage.setItem(SessionsKeys.FibreLeadsAddress, JSON.stringify(LocalConfigs.fibreLeadsAddress));
    }
    console.log('Successfully loaded local FibreLeadsAddress to session storage!');
  } catch (e) {
    console.error('Failed to load FibreLeadsAddress to session storage.', e);
  }
};

const loadScript = (src) => {
  const script = document.createElement('script');
  script.src = src; // URL for the third-party library being loaded.
  script.id = 'libraryName';
  document.body.appendChild(script);
};

class App extends React.Component {
  static contextType = SalesContext;

  componentDidMount() {
    let envObj = {
      'wwwdev.vodacom.co.za' : 'dev',
      'wwwqa.vodacom.co.za' : 'qa',
      'wwwstg.vodacom.co.za' : 'prod',
      'www.vodacom.co.za' : 'prod',
      'localhost' : 'qa'
    };
    let hostname = window.location.hostname;

    loadScript(`https://tags.tiqcdn.com/utag/vodafone/za-microservice/${ envObj[hostname] }/utag.js`);

    function checkIfReady(resolve) {

      const interval = setInterval(() => {
        if(window.utag) {
          resolve(interval);
        }
      }, 1000);
    }

    function ready(interval){
      clearInterval(interval);
      setTrackingIds();
    }

    const waitUntilReady = new Promise(checkIfReady);
    waitUntilReady.then(ready);

    loadDevSessionsData();
  }

  render() {
    return (
      <div className="App">
        { this.context.showSpinner ? <Loader /> : null }

        { this.context.showCallMeBack
          ? <CallMeBackPopup />
          : null
        }

        <BrowserRouter>
          <Switch>
            <Route
              exact
              path="/"
            >
              <Redirect to={Routes.ChoosePlan.path}></Redirect>
            </Route>

            { Object.values(Routes).map((routeConfig) => (
              <NavLayoutRouteWrapper
                key={routeConfig.page}
                exact={routeConfig.exact}
                path={routeConfig.path}
                component={routeConfig.component}
                { ...routeConfig }
              />
            ))
            }

          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
